/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const invoiceLocaleSchema = z.enum(['en-GB', 'de-DE', 'fi-FI'])

export type InvoiceLocaleSchema = z.infer<typeof invoiceLocaleSchema>
